import styled from 'styled-components';

export const Content = styled.h4`
  font-size: 1.125rem;
  font-weight: 300;
  color: #ffffff;
  opacity: 0.4;
  margin: 15px 0 43px 0;

  @media (max-width: 1024px) {
    font-size: 5vw;
    margin: 5% 15% 0 15%;
  }

  @media (max-width: 960px) {
    font-size: 5vw;
    margin: 5% 15% 0 15%;
  }
`;
